/*
 * View controlling the list of tasks for the reviewer UI.  Each ItemView represents the tasks for
 * a single topic.  As a result, a single ItemView can represent more than one task.  Simply clicking
 * on an itemView does not give us enough info to select a task.  Therefore, we mark each task in the itemView
 * with a data-task-id HTML5 attribute.  We then pass the taskId with the "selected:review" event.
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/reviewer/reviewerList/template/reviewerItemTemplate.html",
  "modules/reviewer/reviewerList/template/reviewerEmptyListTemplate.html",
], function ($, Marionette, Messenger, ReviewerItemTemplate, ReviewerEmptyListTemplate) {
  "use strict";

  const ReviewerListView = {};

  ReviewerListView.reviewerItemView = Marionette.ItemView.extend({
    template: ReviewerItemTemplate,
    events: {
      "click .review-item": function (e) {
        //need to figure out which task in the itemView was clicked on and get the taskId
        //taskId might be a string if it is for a Task and Step
        const taskId = $(e.currentTarget).attr("data-task-id");
        this.toggleSelected(taskId);
        this.trigger("selected:review", taskId);
      },
    },
    modelEvents: {
      sync: "render",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateUtc:short", date);
      },
    },
    toggleSelected: function (taskId) {
      this.$el
        .find(".review-item[data-task-id=" + taskId + "]")
        .toggleClass("selected-review-item");
    },
  });

  //View for when the list has no items in it

  ReviewerListView.emptyView = Marionette.ItemView.extend({
    template: ReviewerEmptyListTemplate,
  });

  ReviewerListView.reviewerListView = Marionette.CollectionView.extend({
    //template: ReviewerListTemplate,
    itemView: ReviewerListView.reviewerItemView,
    emptyView: ReviewerListView.emptyView,
    //itemViewContainer: "#reviewList",
    collectionEvents: {
      sort: "render",
    },
  });

  return ReviewerListView;
});
